/* eslint-disable class-methods-use-this */

import {AtomParamTypesEnum} from '../expressionAtomModel';
import {buildParameter} from '../expressionParamHelpers';
import {JsonResult, MethodCategoriesEnum, StaticallyTypedMethod} from './internal';

export class JsonObjectProperty extends StaticallyTypedMethod {
  constructor() {
    super(MethodCategoriesEnum.PARSE, JsonResult);
  }

  getParameters() {
    return [buildParameter('name', AtomParamTypesEnum.STRING)];
  }
}
